<template>
  <div>
    <v-banner
      style="
        height: fit-content;
        width: fit-content;
        object-fit: cover;
        position: relative;
        left: -5px;
      "
    >
      <img width="100%" src="@/assets/images/cyber-banner.webp" />
    </v-banner>
  </div>
</template>

<script>
export default {};
</script>
<style></style>
